// extracted by mini-css-extract-plugin
export default {"pageCenter":"Success_pageCenter__1WHOl","card":"Success_card__CmI-Y","icon":"Success_icon__YFGum","heading":"Success_heading__bExCx","message":"Success_message__3Pauw"};